import { render, staticRenderFns } from "./AdministrationSideMenuDetail.vue?vue&type=template&id=87952894&scoped=true"
import script from "./AdministrationSideMenuDetail.vue?vue&type=script&lang=js"
export * from "./AdministrationSideMenuDetail.vue?vue&type=script&lang=js"
import style0 from "./AdministrationSideMenuDetail.vue?vue&type=style&index=0&id=87952894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87952894",
  null
  
)

export default component.exports